export const urlValidationPattern = {
  value: new RegExp("^https?://"),
  message: "validationErrors.invalidUrl",
};

export const REQUIRED_ERROR_KEY = "validationErrors.required";
